var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52686 5.18667V11.6733C1.52686 12.94 2.42686 13.46 3.52019 12.8333L5.08686 11.94C5.42686 11.7467 5.99352 11.7267 6.34686 11.9067L9.84686 13.66C10.2002 13.8333 10.7669 13.82 11.1069 13.6267L13.9935 11.9733C14.3602 11.76 14.6669 11.24 14.6669 10.8133V4.32667C14.6669 3.06 13.7669 2.54 12.6735 3.16667L11.1069 4.06C10.7669 4.25333 10.2002 4.27333 9.84686 4.09333L6.34686 2.34667C5.99352 2.17333 5.42686 2.18667 5.08686 2.38L2.20019 4.03333C1.82686 4.24667 1.52686 4.76667 1.52686 5.18667Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70654 2.66667V11.3333",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4868 4.41333V13.3333",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityHub);
export default __webpack_public_path__ + "static/media/city-hub.c97efb2385721987e22a06f1848bb3ef.svg";
export { ForwardRef as ReactComponent };